// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { ArrowLeft, ArrowRight, Check } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui'
import { ROUTES } from '@/lib/constants/routes'

interface OnboardingNavProps {
  currentStep:  number
  totalSteps:   number
  canContinue:  boolean
  isSubmitting: boolean
  onPrev:       () => void
  onNext:       () => void
  nextLabel?:   string
}

export function OnboardingNav({
  currentStep,
  totalSteps,
  canContinue,
  isSubmitting,
  onPrev,
  onNext,
  nextLabel,
}: OnboardingNavProps) {
  const navigate = useNavigate()
  const isFirst = currentStep === 1
  const isLast  = currentStep === totalSteps

  return (
    <div className="flex items-center gap-3 mt-8">
      {isFirst ? (
        <button
          type="button"
          onClick={() => navigate(ROUTES.LOGIN)}
          className="flex items-center gap-1 text-xs text-ink-4 hover:text-ink-3 transition-colors flex-shrink-0 px-1"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          <span>Terug</span>
        </button>
      ) : (
        <Button
          type="button"
          variant="ghost"
          size="md"
          onClick={onPrev}
          disabled={isSubmitting}
          icon={<ArrowLeft className="h-4 w-4" />}
          className="flex-shrink-0"
        >
          Terug
        </Button>
      )}

      <Button
        type="button"
        variant="primary"
        size="md"
        fullWidth
        disabled={!canContinue}
        loading={isSubmitting}
        onClick={onNext}
        iconRight={isLast
          ? <Check className="h-4 w-4" />
          : <ArrowRight className="h-4 w-4" />
        }
      >
        {nextLabel ?? (isLast ? 'Account aanmaken' : 'Volgende')}
      </Button>
    </div>
  )
}
